
<template>
  <div>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>配送加价规则</span>
      </div>
      <div  class="text item">
    <div>
      <el-form :model="form" ref="form"  label-width="100px" class="demo-dynamic">
        <el-form-item
          prop="title"
          label="名称"
          :rules="[
            { required: true, message: '请输入名称' },
          ]"
        >
          <el-input  v-model="form.title"></el-input>
        </el-form-item>
         <el-form-item
          prop="status"
          label="状态"
         >
            <el-switch
              v-model="form.status"
              active-text="启用"
              inactive-text="禁用">
            </el-switch>
         </el-form-item>
    <!--    <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>配送时效  单位/km</span>
             <el-button @click="addDomain('delivery_time_limit')"size="mini" type="primary" >新增+</el-button>
          </div>
          <div  class="text item">

                 <div  v-for="(item, index) in form.delivery_time_limit"  :key="item.key">
                     </el-form-item>
                       <el-form-item
                         :label="'起始距离' "
                         :prop="'delivery_time_limit.' + index + '.start'"
                          :rules="[
                            {required: true, message: '起始距离不能为空'},
                          ]"
                         style="display: inline-block;"
                       >
                         <el-input v-model="item.start" size="mini"  type="text" maxlength="5" show-word-limit placeholder="请输入起始距离Km" ></el-input>
                       </el-form-item>
                       <el-form-item
                         :label="'终止距离' "
                         :prop="'delivery_time_limit.' + index + '.end'"
                         :rules="[
                           {required: true, message: '终止距离不能为空'},
                         ]"
                         style="display: inline-block;"
                       >
                         <el-input v-model="item.end" size="mini"  type="text" maxlength="5" show-word-limit placeholder="请输入终止距离Km" ></el-input>
                       </el-form-item>
                     <el-form-item
                     :label="'配送时效'"
                     :prop="'delivery_time_limit.' + index + '.value'"
                     :rules="[
                       {required: true, message: '配送时效不能为空'},
                     ]"
                     style="display: inline-block;"
                     >
                       <el-input v-model="item.value"size="mini"  type="text" maxlength="5"
                       show-word-limit
                       placeholder="请输入配送时效 单位/分钟" ></el-input>
                     </el-form-item>
                       <el-button  type="danger" size="mini" v-if="index >0"  @click.prevent="removeDomain(item,'delivery_time_limit')" >X</el-button>
                 </div>
              </div>
        </el-card> -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>范围规则  单位/km</span>
            <el-button @click="addDomain('distance_rule')" type="primary" size="mini">新增+</el-button>
          </div>
        <div  class="text item">
               <div  v-for="(item, index) in form.distance_rule" :key="item.key">
                     <el-form-item
                       :label="'起始距离' "
                       :prop="'distance_rule.' + index + '.start'"
                        :rules="[
                          {required: true, message: '起始距离不能为空'},
                        ]"
                       style="display: inline-block;"
                     >
                       <el-input v-model="item.start"  size="mini" type="text" maxlength="5" show-word-limit placeholder="请输入起始距离Km" ></el-input>
                     </el-form-item>
                     <el-form-item
                       :label="'终止距离' "
                       :prop="'distance_rule.' + index + '.end'"
                       :rules="[
                         {required: true, message: '终止距离不能为空'},
                       ]"
                       style="display: inline-block;"
                     >
                       <el-input v-model="item.end"  size="mini" type="text" maxlength="5" show-word-limit placeholder="请输入终止距离Km" ></el-input>
                     </el-form-item>
                   <el-form-item
                   :label="'加价金额'"
                   :prop="'distance_rule.' + index + '.value'"
                   :rules="[
                     {required: true, message: '加价金额不能为空'},
                   ]"
                   style="display: inline-block;"
                   >
                     <el-input v-model="item.value" size="mini" type="text" maxlength="5"
                     show-word-limit
                     placeholder="请输入加价金额" ></el-input>
                   </el-form-item>
                     <el-button  type="danger"size="mini"  v-if="index >0" @click.prevent="removeDomain(item,'distance_rule')" >X</el-button>
               </div>
        </div>
      </el-card>

  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>重量规则 单位/kg</span>
       <el-button @click="addDomain('weigh_rule')"size="mini" type="primary" >新增+</el-button>
    </div>
    <div  class="text item">
           <div  v-for="(item, index) in form.weigh_rule"   :key="item.key">
                 <el-form-item
                   :label="'起始重量' "
                   :prop="'weigh_rule.' + index + '.start'"
                    :rules="[
                      {required: true, message: '起始重量不能为空'},
                    ]"
                   style="display: inline-block;"
                 >
                   <el-input v-model="item.start" size="mini"  type="text" maxlength="5" show-word-limit placeholder="请输入起始重量Kg" ></el-input>
                 </el-form-item>
                 <el-form-item
                   :label="'终止重量' "
                   :prop="'weigh_rule.' + index + '.end'"
                   :rules="[
                     {required: true, message: '终止重量不能为空'},
                   ]"
                   style="display: inline-block;"
                 >
                   <el-input v-model="item.end" size="mini"  type="text" maxlength="5" show-word-limit placeholder="请输入终止重量Kg" ></el-input>
                 </el-form-item>
               <el-form-item
               :label="'加价金额'"
               :prop="'weigh_rule.' + index + '.value'"
               :rules="[
                 {required: true, message: '加价金额不能为空'},
               ]"
               style="display: inline-block;"
               >
                 <el-input v-model="item.value"size="mini"  type="text"
                 show-word-limit  maxlength="5"
                 placeholder="请输入加价金额" ></el-input>
               </el-form-item>
                 <el-button  type="danger" size="mini" v-if="index >0" @click.prevent="removeDomain(item,'weigh_rule')" >X</el-button>
           </div>

    </div>
  </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>时间规则</span>
             <el-button @click="addDomain('time_rule')"size="mini" type="primary" >新增+</el-button>
          </div>
          <div  class="text item">
               <div  v-for="(item, index) in form.time_rule"  :key="item.key">
                     <el-form-item
                       :label="'起始时间' "
                       :prop="'time_rule.' + index + '.start'"
                        :rules="[
                          {required: true, message: '起始时间不能为空'},
                        ]"
                       style="display: inline-block;"
                     >
                     <el-time-select
                     size="mini"
                       v-model="item.start"
                       :picker-options="{
                         start: '00:00',
                         step: '00:01',
                         end: '23:59'
                       }"
                       placeholder="请输入起始时间" >
                     </el-time-select>
                     </el-form-item>
                     <el-form-item
                       :label="'终止时间' "
                       :prop="'time_rule.' + index + '.end'"
                       :rules="[
                         {required: true, message: '终止时间不能为空'},
                       ]"
                       style="display: inline-block;"
                     >
                     <el-time-select
                     size="mini"
                       v-model="item.end"
                       :picker-options="{
                         start: '00:00',
                         step: '00:01',
                         end: '23:59'
                       }"
                       placeholder="请输入终止时间" >
                     </el-time-select>
                     </el-form-item>
                   <el-form-item
                   :label="'加价金额'"
                   :prop="'time_rule.' + index + '.value'"
                   :rules="[
                     {required: true, message: '加价金额不能为空'},
                   ]"
                   style="display: inline-block;"
                   >
                     <el-input v-model="item.value" size="mini" type="text" maxlength="5"
                     show-word-limit
                     placeholder="请输入加价金额" ></el-input>
                   </el-form-item>
                     <el-button  type="danger" size="mini"  v-if="index >0" @click.prevent="removeDomain(item,'time_rule')" >X</el-button>
               </div>
            </div>
        </el-card>

  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>其他加价</span>
       <el-button @click="addDomain('other_rule')"size="mini" type="primary" >新增+</el-button>
    </div>
    <div  class="text item">
         <div  v-for="(item, index) in form.other_rule"  :key="item.key">
               <el-form-item
                 :label="'描述' "
                 :prop="'other_rule.' + index + '.name'"
                  :rules="[
                    {required: true, message: '描述不能为空'},
                  ]"
                 style="display: inline-block;"
               >
               <el-input v-model="item.name" size="mini" type="text"  placeholder="请输入描述" ></el-input>
               </el-form-item>
              <el-form-item
                :label="'开始时间' "
                :prop="'other_rule.' + index + '.start'"
                 :rules="[
                   {required: true, message: '时间不能为空'},
                 ]"
                style="display: inline-block;"
              >
               <el-date-picker
               value-format="timestamp"
                size="mini"
                    v-model="item.start"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
              <el-form-item
                :label="'结束时间' "
                :prop="'other_rule.' + index + '.end'"
                 :rules="[
                   {required: true, message: '时间不能为空'},
                 ]"
                style="display: inline-block;"
              >
               <el-date-picker
               value-format="timestamp"
                size="mini"
                    v-model="item.end"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>
             <el-form-item
             :label="'加价金额'"
             :prop="'other_rule.' + index + '.value'"
             :rules="[
               {required: true, message: '加价金额不能为空'},
             ]"
             style="display: inline-block;"
             >
               <el-input v-model="item.value" size="mini" type="text" maxlength="5"
               show-word-limit
               placeholder="请输入加价金额" ></el-input>
             </el-form-item>
               <el-button  type="danger" size="mini"  @click.prevent="removeDomain(item,'other_rule')" >X</el-button>
         </div>
      </div>
  </el-card>

        <el-form-item >
          <el-button type="primary" @click="onSubmit('form')">提交</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
      </div>
    </el-card>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import {
  getMerchantFreight,
  addMerchantFreight,
  editMerchantFreight,
} from "../../../api/merchant";

export default {
  data() {
    return {
      loading: false,
      dataList: [],
      form: {
          status:true,
          title: '配送加价规则',
          delivery_time_limit:[{
            start:0,
            end:0,
            value: 0
          }],
          distance_rule: [{
            start:0,
            end:0,
            value:0
          }],
          weigh_rule: [{
            start:0,
            end:0,
            value: 0
          }],
          time_rule: [{
            start:"00:00",
            end:"23:59",
            value:0
          }],
          other_rule: [{
            name:"",
            start:'',
            end:'',
            value:1
          }],
        }
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  components: { draggable },
  methods: {

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item,rule) {

      this.$confirm("此操作将会移除此项是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
           var index = this.form[rule].indexOf(item)
           if (index !== -1) {
             this.form[rule].splice(index, 1)
           }
        })
        .catch(() => {});
    },
    addDomain(rule) {
      this.form[rule].push({});
    },
    goBack() {
      this.$confirm("此操作返回上一个页面, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          history.back(0);
        })
        .catch(() => {});
    },
    //编辑显示数据
    getRow(id) {
      getMerchantFreight({ id: id }).then((res) => {
        this.form = res.data.data.list[0];
      });
    },
    onSubmit(formName) {
      console.log(this.form);
      var submit = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log(this.form)
          console.log("error submit!!");
          return false;
        } else {
          submit = true;
        }
      });
      if (submit == false) {
        return;
      }

      var that = this;
      if (this.$route.query.id) {
        editMerchantFreight(this.$route.query.id, this.form).then(
          (res) => {
            if (res.status) {
              this.loading = false;
              this.$message({
                message: "修改成功",
                type: "success",
                duration: 2000,
              });
              setTimeout(function () {
                that.$router.go(-1);
              }, 2000);
            } else {
              this.$message.error("修改失败!");
              return false;
            }
          }
        );
      } else {
        addMerchantFreight(this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
            setTimeout(function () {
              that.$router.go(-1);
            }, 2000);
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
      }
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.id != undefined) {
        this.getRow(this.$route.query.id);
    }
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// edit.vue?4562ce00